if (!window.infoTipInit) {
  window.infoTipInit = true;
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.info-tip.is-open').forEach(function (tip) {
      if (!tip.contains(e.target)) tip.classList.remove('is-open');
    });
    var btn = e.target.closest('.info-tip__icon');
    if (btn) btn.parentElement.classList.toggle('is-open');
  });
}